export function convertFileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            resolve(reader.result);
        };

        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsDataURL(file);
    });
}

// Fonction pour vérifier si l'URL est une URL de vidéo
export function isVideoUrl(url) {
    // Expression régulière pour vérifier si l'URL se termine par une extension de fichier vidéo
    const videoExtensions = /\.(mp4|mov|avi|wmv|flv)$/i;
    return videoExtensions.test(url);
}
